import React, { useState, useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import BarraLateral from './BarraLateral';
import BarraNavegacion from './BarraNavegacion';
import AlertaCobranza from './AlertaCobranza';
import BloqueoCobranzaModal from './BloqueoCobranzaModal';
import { AuthContext } from '../context/AuthContext';
import cobranzasService from '../services/cobranzasService';

const Diseno = ({ children }) => {
    const { user, logout } = useContext(AuthContext);
    const location = useLocation();

    const [cobranzaStatus, setCobranzaStatus] = useState(null);
    const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(false);

    const isExemptRole = user?.role_details?.name === 'GESTOR_COBRANZAS' || user?.role_details?.name === 'SUPER_ADMIN' || user?.is_superuser;

    const fetchCobranzaStatus = async () => {
        if (!user || isExemptRole) return;
        try {
            const data = await cobranzasService.getMyStatus();
            setCobranzaStatus(data);
        } catch (error) {
            console.error('Error obteniendo estado de cobranza:', error);
        }
    };

    useEffect(() => {
        fetchCobranzaStatus();
    }, [user]);

    // Cerrar menú móvil al cambiar de ruta
    useEffect(() => {
        setIsMobileMenuOpen(false);
    }, [location.pathname]);

    const isBlocked = !isExemptRole && Boolean(cobranzaStatus?.is_blocked);
    const showUploadModal = isBlocked || isUploadModalOpen;

    const handleSuccessUpload = async (res) => {
        setIsUploadModalOpen(false);
        try {
            const data = await cobranzasService.getMyStatus();
            setCobranzaStatus(data);
        } catch (err) {
            console.error('Error refrescando estado de cobranza:', err);
        }
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(prev => !prev);
    };

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
    };

    const toggleSidebar = () => {
        setIsCollapsed(prev => !prev);
    };

    return (
        <div className={`app-layout ${isCollapsed ? 'sidebar-collapsed' : ''}`}>
            {/* Barra de Navegación Superior para Móviles y Tablets */}
            <BarraNavegacion
                onToggleMobileMenu={toggleMobileMenu}
                isMobileMenuOpen={isMobileMenuOpen}
            />

            <div className="app-layout-body">
                {/* Barra Lateral Navegación */}
                <BarraLateral
                    isMobileOpen={isMobileMenuOpen}
                    onCloseMobile={closeMobileMenu}
                    isCollapsed={isCollapsed}
                    toggleSidebar={toggleSidebar}
                />

                {/* Contenedor Principal de Contenido */}
                <main className="app-main-content">
                    {/* Banner de Aviso de Pago (Días 1-5 o En Revisión) */}
                    {!isExemptRole && (
                        <AlertaCobranza
                            cobranzaStatus={cobranzaStatus}
                            onOpenUploadModal={() => setIsUploadModalOpen(true)}
                        />
                    )}

                    {/* Contenido de la página */}
                    <div className="page-content-wrapper">
                        {children}
                    </div>

                    {/* Modal de Bloqueo / Subida de Comprobante */}
                    {!isExemptRole && (
                        <BloqueoCobranzaModal
                            isOpen={showUploadModal}
                            isBlocked={isBlocked}
                            cobranzaStatus={cobranzaStatus}
                            onClose={() => setIsUploadModalOpen(false)}
                            onSuccessUpload={handleSuccessUpload}
                            onLogout={logout}
                        />
                    )}
                </main>
            </div>
        </div>
    );
};

export default Diseno;